export const lastActionKey = 'PORTAL_LAST_ACTION';
